import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { isAdminAuthenticated } from '../services/adminAuth';

interface AdminGuardProps {
  children: React.ReactNode;
}

/** Verifica cookie admin vs hash Firebase prima di mostrare la dashboard. */
export function AdminGuard({ children }: AdminGuardProps) {
  const [state, setState] = useState<'loading' | 'ok' | 'deny'>('loading');

  useEffect(() => {
    let cancelled = false;
    isAdminAuthenticated().then((ok) => {
      if (!cancelled) setState(ok ? 'ok' : 'deny');
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === 'loading') {
    return (
      <Box
        sx={{
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (state === 'deny') {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
}
